import React from "react";
import { Navigate } from "react-router-dom";
import AdminAlertsPage from "./admin";
import UserAlertsPage from "./user";
import { getUserInfo } from "../../helpers/user";

const AlertsPageRouteWrapper = () => {
  const userInfo = getUserInfo();

  if (userInfo.role === "admin") {
    return <AdminAlertsPage />;
  } else if (userInfo.role === "user" || userInfo.role === "org_admin") {
    return <UserAlertsPage />;
  } else {
    return <Navigate to="/login" />;
  }
};

export default AlertsPageRouteWrapper;
